import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton, H2, H1 } from '../../StyledComponents';

import HeroBgMobile from '../../../assets/v2/Hardware/hardware-mobile.jpg';
import { navigate } from 'gatsby';
import Tablet from '../../../assets/v2/Health/TabletHealth.png';
import Kiosk from '../../../assets/v2/Health/KioskHealth.png';
import Remote from '../../../assets/v2/Health/RemoteHealth.png';

const SectionOne = styled.div`
  background-repeat: no-repeat;
  padding-bottom: 5rem !important;
  background: #eef7ff;
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 0rem !important;
  }
  width: 100%;
  display: grid;
`;
const BgContainer = styled(SectionParent)`
  background: #eef7ff;
  padding-top: 8rem !important;
  padding-left: 0;
  padding-right: 0%;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 0rem;
    padding-left: 0;
    padding-right: 0%;
  }
  @media (max-width: 1250px) and (min-width: 768px) {
    padding-bottom: 0rem;
  }
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 8rem !important;
    /* background-image: url(${HeroBgMobile}); */
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
    padding-bottom: 0;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled.div`
  color: #151828;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  font-size: 48px;
  @media (max-width: 768px) {
    margin-top: 1rem;
    font-size: 24px;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-left: 0;
    font-size: 22px;
    padding: 0 2rem;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;

const GridRight = styled.div`
  grid-column: span 2;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;

const HeroSubTitle = styled(SectionParent)`
  padding-top: 1.5rem;
  /* margin-left: 3rem;
  margin-right: 3rem; */
  padding: 0 14rem;
  width: 70%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  /* text-shadow: 0px 1px #000000; */
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  @media (max-width: 1440px) and (min-width: 780px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 100%;
    padding-top: 0.5rem;
    line-height: 1.5;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 2rem;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  background-color: #725cbd;
  color: #ffffff;
`;
const HeroImgContainerLeft = styled.img`
  width: 100%;
  grid-column: span 1;
  justify-self: center;
  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 520px) {
    width: 90%;
  }
`;
const HeroImgContainer = styled(SectionParent)`
  /* height: 19.7rem; */
  /* padding: 2rem 0rem; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-bottom: 0;
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const SubTitle = styled(H2)`
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.52;
  letter-spacing: normal;
  color: #151828;
  font-family: 'Nunito Sans', sans-serif;
  padding-bottom: 3.5rem;
  text-align: center;
`;
export default class HealthSectionOne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  render() {
    return (
      <div>
        <BgContainer>
          <SectionOneTitle>
            Android for <span style={{ color: '#e84860' }}>Telehealth </span>
            Innovation
          </SectionOneTitle>
          <SubTitle>
            A complete range of compliance-friendly, secure telehealth
            solutions.{' '}
          </SubTitle>
          <HeroImgContainer>
            <HeroImgContainerLeft alt="EsperHardware" src={Remote} />
            <HeroImgContainerLeft alt="EsperHardware" src={Kiosk} />
            <HeroImgContainerLeft alt="EsperHardware" src={Tablet} />
          </HeroImgContainer>
        </BgContainer>
        <SectionOne>
          <SectionItemContainer>
            <BlueButtonWrapper>
              <BlueButtonNew
                id="healthcare__get_started"
                onClick={() => navigate('/signup')}
              >
                Get Started
              </BlueButtonNew>
            </BlueButtonWrapper>
            <HeroSubTitle style={{ paddingTop: '1.5rem' }}>
              Medical device innovation is driving industry transformation by
              improving access to care and lowering patient costs. Android
              telehealth is changing the world, one patient at a time by
              redefining quality-of-life and care outcomes.
            </HeroSubTitle>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
